module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0zm5.442 18.718a1.923 1.923 0 0 1-2.718 2.718l-2.72-2.718-2.718 2.718a1.923 1.923 0 0 1-2.718-2.718L13.286 16l-2.72-2.718a1.923 1.923 0 0 1 2.718-2.718l2.718 2.718 2.718-2.718a1.923 1.923 0 0 1 2.718 2.718L18.722 16l2.72 2.718z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/x-2.js
// module id = 1506
// module chunks = 14